export default __webpack_public_path__ + "static/media/menu-active.d6a01a09.svg";